import React, { useMemo } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { Flyer } from '@/graphql/types';
import styles from './ExpiredFlyerDetails.styles';
import { BodySmall, BodySmallMidEmphasis, TitleSmallEmphasized } from '@/design-system';
import colors from '@/theme/colors';
import { FlyerDetailsSwiper } from '../FlyerDetailsSwiper';
import { TrackingFrom } from '@/hooks';
import { FlyerDetailsNavBar } from '../FlyerDetailsNavBar/FlyerDetailsNavBar';

interface Props {
  isCommunity: boolean;
  backButton: () => void;
  flyer: Flyer;
  trackingFrom: TrackingFrom;
  loadingFlyer: boolean;
  onLoadFlyer: () => void;
  flyerTitle: string;
}

export const ExpiredFlyerDetails: React.FC<Props> = ({
  flyer,
  isCommunity,
  backButton,
  trackingFrom,
  loadingFlyer,
  onLoadFlyer,
  flyerTitle,
}) => {
  const dateFns = new DateFnsUtils();
  const expiredOnDate = useMemo(
    () => dateFns.formatByString(new Date(flyer.endDate), 'MMMM dd, yyyy'),
    [flyer]
  );

  return (
    <div className={styles.container}>
      <FlyerDetailsNavBar onClick={backButton} iconPosition="left" />
      <main>
        <FlyerDetailsSwiper
          flyer={flyer}
          loadingFlyer={loadingFlyer}
          isExpired={true}
          onLoadFlyer={onLoadFlyer}
          slideSwiper={() => null}
          trackingFrom={trackingFrom}
          flyerTitle={flyerTitle}
        />
        <div className={styles.contentColumn}>
          <BodySmall color={colors.dragon}>Expired on {expiredOnDate}</BodySmall>
          <BodySmall color={colors.neutralAsh}>Flyer ID {flyer.flyerId}</BodySmall>
        </div>
        <div className={styles.flyerDetailsInfo}>
          <TitleSmallEmphasized nonTranslate color={colors.neutralAsh} data-testid="flyerTitle">
            {flyerTitle}
          </TitleSmallEmphasized>
          {isCommunity && flyer.org?.name && (
            <div>
              <BodySmallMidEmphasis nonTranslate color={colors.neutralAsh}>
                {`by ${flyer.org?.name}`}
              </BodySmallMidEmphasis>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};
